import React from 'react';
import DeleteIcon from '@mui/icons-material/Delete';
import DownloadIcon from '@mui/icons-material/Download';
import EditIcon from '@mui/icons-material/Edit';

import { TooltipIconButton } from '@paragon/client-tools';

import {
  showConfirmRemoveBundleFromTruckloadDialog,
  showDownloadBillOfLadingDialog,
  showEditTruckloadDialog,
} from '../../../actions/dialogActions';
import { TruckloadGridRow } from '../../../selectors/truckloadGrid';
import { useAppDispatch } from '../../hooks';

const buttonSx = { height: 20, width: 20, ml: 0.5, mr: 0.5 };

interface TruckloadGridRowActionsProps {
  row: TruckloadGridRow;
}

export function TruckloadGridRowActions(props: TruckloadGridRowActionsProps) {
  const { row } = props;
  const { guid, type } = row;
  const dispatch = useAppDispatch();

  switch (type) {
    case 'truckload':
      return (
        <>
          <TooltipIconButton
            title="Edit truckload"
            sx={buttonSx}
            onClick={(event) => {
              event.stopPropagation();
              dispatch(showEditTruckloadDialog(guid));
            }}
          >
            <EditIcon />
          </TooltipIconButton>
          <TooltipIconButton
            title="Download bill of lading"
            sx={buttonSx}
            onClick={(event) => {
              event.stopPropagation();
              dispatch(showDownloadBillOfLadingDialog(guid));
            }}
          >
            <DownloadIcon />
          </TooltipIconButton>
        </>
      );
    case 'bundle':
      return (
        <TooltipIconButton
          title="Remove bundle from truckload"
          sx={buttonSx}
          onClick={(event) => {
            event.stopPropagation();
            dispatch(showConfirmRemoveBundleFromTruckloadDialog(guid));
          }}
        >
          <DeleteIcon />
        </TooltipIconButton>
      );
    default:
      return null;
  }
}
